export enum Routes {
  Home = '/',
  Login = '/login',
  Logout = '/logout',
  FAQ = '/faq',
  Announcements = '/announcements',
  ResetPassword = '/reset-password',


  UserActivityReport = '/user/activity-report',
  UserCart = '/user/cart',
  UserWallet = '/user/wallet',
  UserProfile = '/user/profile',
  // UserChangePassword = '/user/change-password',
  // UserChangeCVV2 = '/user/change-cvv2',

  UserAuthorize = '/user/authorize',
  UserMessages = '/user/messages',
  UserMessageView = '/user/messages/:id',
  UserFeedbacks = '/user/feedbacks',
  UserFeedback = '/user/feedbacks/:id',

  Food = '/food',
  FoodSelfs = '/food/selfs',
  FoodReserve = '/food/reserve',
  FoodDailySale = '/food/dailysale',
  FoodTeammate = '/food/teammate',
  FoodReservesReport = '/food/reserves-report',

  Sport = '/sport',
  SportGyms = '/sport/gyms',
  SportReserve = '/sport/reserve',
  SportDailySale = '/sport/dailysale',
  SportReservesReport = '/sport/reserves-report',

  Health = '/health',
  HealthClinics = '/health/clinics',
  HealthReserve = '/health/reserve',
  HealthDailySale = '/health/dailysale',
  HealthReservesReport = '/health/reserves-report',

  Transport = '/transport',
  TransportTerminals = '/transport/terminals',
  TransportReserve = '/transport/reserve',
  TransportDailySale = '/transport/dailysale',
  TransportReservesReport = '/transport/reserves-report',

  Helpdesk = '/helpdesk',
  HelpdeskIssues = '/helpdesk/issues',
  HelpdeskCreateIssue = '/helpdesk/create-issue',
  HelpdeskViewIssue = '/helpdesk/issues/:issueId',

  Dormitory = '/dormitory',
  DormitoryRegister = '/dormitory/register',
  DormitoryPreRegister = '/dormitory/pre-register',
  DormitoryAttendanceReport = '/dormitory/attendance-report',
  DormitoryLaundry = '/dormitory/laundry',
  DormitoryLeave = '/dormitory/leave',
  DormitoryLeaveReport = '/dormitory/leave-report',
  DormitoryGroupRoomSelector = '/dormitory/register/group-room-selector',
  DormitorySolitrayRoomSelector = '/dormitory/register/solitary-room-selector',
  DormitoryCardexes = '/dormitory/cardexes',

  Face = '/face',
  FaceEnrollment = '/face/enrollment',

  ModuleInactive = '/modules/inactive',

  Surveys = '/surveys',
  SurveyParticipate = '/survey/:surveyId',
}

export const ROOT_OF_MODULES = [
  Routes.Home,
  Routes.Food,
  Routes.Sport,
  Routes.Health,
  Routes.Helpdesk,
  Routes.Dormitory,
  Routes.Transport,
  Routes.Face,
];

export const isRootOfModule = (value: string | Routes) =>
  ROOT_OF_MODULES.includes(value as any);
